import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import RedoIcon from '@material-ui/icons/Redo';
import UndoIcon from '@material-ui/icons/Undo';
import i18n from 'i18n-js';

import { theme } from 'config/theme';
import { useTableMapWizard } from '../context';
import useUndoRedoShortcuts from '../useUndoRedoShortcuts';

const useStyles = makeStyles({
    historyButton: {
        minWidth: 32,
        height: 32,
        padding: 0,
        backgroundColor: 'white',
        color: theme.palette.text.primary,
        borderColor: theme.palette.grey['300'],
        '&:hover': {
            backgroundColor: theme.palette.grey['300'],
        },
    },
});

export default function TableHistoryControls() {
    const classes = useStyles();
    const { draft, dispatch } = useTableMapWizard();
    const isLocked = draft.pendingTable !== null;
    const canUndo = !isLocked && draft.tableHistory.past.length > 0;
    const canRedo = !isLocked && draft.tableHistory.future.length > 0;

    const undo = () => dispatch({ type: 'UNDO_TABLE_EDIT' });
    const redo = () => dispatch({ type: 'REDO_TABLE_EDIT' });
    useUndoRedoShortcuts(undo, redo, true);

    return (
        <>
            <Button
                variant="outlined"
                className={classes.historyButton}
                onClick={undo}
                disabled={!canUndo}
                aria-label={i18n.t('tableMaps.wizard.draw.undo')}
                title={i18n.t('tableMaps.wizard.draw.undo')}
            >
                <UndoIcon fontSize="small" />
            </Button>
            <Button
                variant="outlined"
                className={classes.historyButton}
                onClick={redo}
                disabled={!canRedo}
                aria-label={i18n.t('tableMaps.wizard.draw.redo')}
                title={i18n.t('tableMaps.wizard.draw.redo')}
            >
                <RedoIcon fontSize="small" />
            </Button>
        </>
    );
}
